import type { UserType } from "../types";

/** Match backend typography loosely (fancy apostrophes, trim). */
function norm(s: string): string {
  return s
    .replace(/\u2019/g, "'")
    .replace(/\u2018/g, "'")
    .replace("`", "'")
    .trim()
    .replace(/\s+/g, " ");
}

/**
 * All self-registration / claim JIT accounts use store_employee portal class;
 * leadership vs hourly is expressed via ``employee_type`` only.
 */
export function inferUserTypeForCatalogRole(): UserType {
  return "store_employee";
}

/**
 * Map a catalogue role string to Workvivo employee_type (hourly vs salaried_manager).
 */
export function inferEmployeeTypeForCatalogRole(roleTitle: string): "hourly" | "salaried_manager" {
  const t = norm(roleTitle).toLowerCase();

  if (t === "executives") return "salaried_manager";

  const leaderFragments = [
    "assistant general manager",
    "general manager",
    "regional director",
    "district manager",
    "area manager",
  ];
  if (leaderFragments.some((f) => t.includes(f))) return "salaried_manager";

  const leaderSuffixes = [
    /\bchief\b/i,
    /\bcontroller\b$/i,
    /\boperations manager\b/i,
    /\bfinance manager\b/i,
  ];
  if (leaderSuffixes.some((re) => re.test(norm(roleTitle)))) return "salaried_manager";

  return "hourly";
}
